import React, { useState, useRef } from 'react';
import ReactDOMServer from 'react-dom/server';
import ReCAPTCHA from 'react-google-recaptcha';
import { useForm } from 'react-hook-form';
import ContactEmail from "../../../email/contactEmail";

export default function ContactForm() {
    const [recaptchaToken, setRecaptchaToken] = useState(null);
    const [status, setStatus] = useState({
        submitting: false,
        succeeded: false,
        error: null
    });

    const recaptchaRef = useRef(null);
    const { register, handleSubmit, reset } = useForm();
    const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

    const onRecaptchaChange = (token) => {
        setRecaptchaToken(token);
        if (token) {
            setStatus(prev => ({ ...prev, error: null }));
        }
    };

    const onRecaptchaExpired = () => {
        setRecaptchaToken(null);
    };

    const onSubmit = async (data) => {
        if (!recaptchaToken) {
            setStatus(prev => ({
                ...prev,
                error: 'Por favor completa el captcha antes de enviar.'
            }));
            return;
        }

        setStatus({ submitting: true, succeeded: false, error: null });

        const htmlMessage = ReactDOMServer.renderToStaticMarkup(
            <ContactEmail
                name={data.name}
                email={data.email}
                subject={data.asunto}
                message={data.message}
            />
        );

        data.to = "info@despachozwolf.com";
        data.subject = "Contacto desde la página web";
        data.text = htmlMessage;
        data.recaptcha_token = recaptchaToken;

        try {
            const response = await fetch('https://despachozwolf.com/api/send-email.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            if (response.ok && result.status === 'success') {
                setStatus({ submitting: false, succeeded: true, error: null });
                reset();
                if (recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
                setRecaptchaToken(null);
            } else {
                setStatus({
                    submitting: false,
                    succeeded: false,
                    error: result.message || 'Error al enviar el mensaje. Intente nuevamente.'
                });
                if (recaptchaRef.current) {
                    recaptchaRef.current.reset();
                }
                setRecaptchaToken(null);
            }
        } catch (error) {
            setStatus({
                submitting: false,
                succeeded: false,
                error: 'No se pudo conectar con el servidor. Intente de nuevo más tarde.'
            });
            if (recaptchaRef.current) {
                recaptchaRef.current.reset();
            }
            setRecaptchaToken(null);
        }
    };

    return (
        <div className="container fs-5">
            <div className="row">
                <div className="col text-left pt-5">
                    <h5 className="display-1 uppercase">
                        Contáctanos
                    </h5>
                    <p className="h5">
                        Mándanos un correo y un asesor contable te contactará
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col p-5">
                    <form onSubmit={handleSubmit(onSubmit)} className="needs-validation" noValidate>
                        <div className="mb-3 text-start">
                            <label htmlFor="name" className="form-label">Nombre</label>
                            <input
                                type="text"
                                className="form-control"
                                id="name"
                                {...register("name", { required: true })}
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label htmlFor="email" className="form-label">Correo</label>
                            <input
                                type="email"
                                className="form-control"
                                id="email"
                                {...register("email", { required: true })}
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label htmlFor="asunto" className="form-label">Asunto</label>
                            <input
                                type="text"
                                className="form-control"
                                id="asunto"
                                {...register("asunto", { required: true })}
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label htmlFor="message" className="form-label">Mensaje</label>
                            <input
                                type="text"
                                className="form-control"
                                id="message"
                                {...register("message", { required: true })}
                            />
                        </div>
                        <div className="col mb-3">
                            {siteKey ? (
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={siteKey}
                                    onChange={onRecaptchaChange}
                                    onExpired={onRecaptchaExpired}
                                />
                            ) : (
                                <div className="alert alert-warning py-2 text-start">
                                    <small>Configura <code>REACT_APP_RECAPTCHA_SITE_KEY</code> en tu archivo <code>.env</code></small>
                                </div>
                            )}
                        </div>
                        <div className="col">
                            {status.error && (
                                <p className="text-danger mb-2 text-start">{status.error}</p>
                            )}
                            {!status.succeeded && (
                                <button
                                    type="submit"
                                    className="btn btn-primary btn-lg"
                                    disabled={!recaptchaToken || status.submitting}
                                >
                                    {status.submitting ? 'Enviando...' : 'Enviar'}
                                </button>
                            )}
                            {status.succeeded && (
                                <p className="text-success animate__animated animate__fadeIn">
                                    Enviado, espere respuesta de nuestro equipo
                                </p>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}
